'use strict';exports.__esModule = true;exports.PARAMS = exports.CONSTANTS_COMMENTS = undefined;var _react = require('react');var _react2 = _interopRequireDefault(_react);

var _RealtorLanding = require('../../../static/images/RealtorLanding');var _RealtorLanding2 = _interopRequireDefault(_RealtorLanding);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CONSTANTS_COMMENTS = exports.CONSTANTS_COMMENTS = [
_RealtorLanding2.default.sample1,
_RealtorLanding2.default.sample2,
_RealtorLanding2.default.sample3,
_RealtorLanding2.default.sample4,
_RealtorLanding2.default.sample5,
_RealtorLanding2.default.sample6];


var PARAMS = exports.PARAMS = function PARAMS(activeSlideIndex) {return (
    {
      speed: 500,
      centerMode: true,
      variableWidth: true,
      spaceBetween: 30,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      responsive: [{
        breakpoint: 807,
        settings: {
          speed: 5,
          centerMode: false,
          arrows: false,
          variableWidth: false,
          spaceBetween: 60,
          infinite: true,
          dots: true,
          fade: true,
          swipe: false,
          appendDots: function appendDots(dots) {return (
              _react2.default.createElement('div', {
                  style: {
                    width: '114px',
                    margin: '46px auto 0' } },


                _react2.default.createElement('div', {
                    style: {
                      margin: '0px',
                      display: 'flex',
                      justifyContent: 'space-evenly' } }, ' ',

                  dots, ' ')));},


          customPaging: function customPaging(slideIndex) {return (
              _react2.default.createElement('div', {
                key: slideIndex,
                style:
                slideIndex !== activeSlideIndex ?
                {
                  width: '8px',
                  height: '8px',
                  background: 'rgba(0, 166, 238, 0.2)',
                  borderRadius: '30px' } :
                {
                  width: '8px',
                  height: '8px',
                  background: '#04AAEB',
                  borderRadius: '30px' } }));} } }] });};


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingSliderPhoto/constants.js
// module id = 2700
// module chunks = 0